module.exports = __webpack_public_path__ + "static/media/Lynkit.io.8f6899aa.png";